// extracted by mini-css-extract-plugin
export default {"appointmentsList":"appointments-list_appointmentsList__MIKcm","emptyState":"appointments-list_emptyState__-P5b8","loadingState":"appointments-list_loadingState__Y6mRD"};